import {
  React,
  Link,
  Select,
  Divider,
  Switch,
  ScreenWisePostScheduling,
  PlayCircleOutlineIcon,
  useGetAllScreenPostsMutation,
  useUpdateScreenWisePostStatusMutation,
  useDeletePostMutation,
  useChangePostOrderMutation,
  PostPlaying,
  EditIcon,
  MoreVertIcon,
  useNavigate,
  alpha,
  Menu,
  MenuItem,
  DeleteForeverIcon,
  useEffect,
  memo,
  useCallback,
  useLocation,
  Button,
  toast,
  useState,
  LoadingSpinner,
  Grid,
  Paper,
  Box,
  Add,
  styled,
  swal,
  useGetAllScreensMutation,
  Empty,
  Modal,
  GetCookie,
  AccessTimeIcon,
} from "../../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const GetAllPostRelatedToTheScreen = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const [deletePost, { isLoading: deleteloading }] = useDeletePostMutation();
  const [getAllPostRelatedToTheScreen, { isLoading }] =
    useGetAllScreenPostsMutation();
  const [getAllScreensfromdb, { isLoading: loading }] =
    useGetAllScreensMutation();
  const [ChangeOrder, { isLoading: changeorderloading }] =
    useChangePostOrderMutation();
  const [ScreenPostStatusChange, { isLoading: screenwisePostStatusloading }] =
    useUpdateScreenWisePostStatusMutation();

  // const [refreshscreen, { isLoading: refreshscreenloading }] =
  //   useRefreshScreenMutation();

  const [options, setoptions] = useState([]);
  const [defaultScreen, setDefaultScreen] = useState(location?.state);

  const [allposts, setallposts] = useState();
  const [orders, setorders] = useState();
  const [totalduration, settotalduration] = useState();

  const [clickedPost, setclickedPost] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const [data, setdata] = useState({
    playingpost: false,
    selectedpost: null,
    screenwisePostStatuscomponent: false,
  });

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setclickedPost(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getAllScreens = useCallback(async () => {
    try {
      const verifyscreenotp = new FormData();
      verifyscreenotp.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      verifyscreenotp.append("security_token", await GetCookie("es_token"));

      const returned = await getAllScreensfromdb(verifyscreenotp).unwrap();
      if (
        returned.status === "true" &&
        returned.connection === "true" &&
        returned.message === "Screens available"
      ) {
        const result = returned.data.map((option) => {
          const formatedresult = {
            value: option.ser_screen_id,
            label: option.txt_screen_name,
          };
          return formatedresult;
        });
        setoptions(result);
        setDefaultScreen(location?.state ? location.state : [result[0]]);
      } else {
        toast.info(returned.message);
      }
    } catch (error) {
      toast.error(error.error);
      console.error(error);
    }
  }, [getAllScreensfromdb, location]);

  //This will display all the post
  const getAllPosts = useCallback(
    async (screen) => {
      var jsonObj = {
        txt_customer_id: localStorage.getItem("txt_customer_id"),
        security_token: await GetCookie("es_token"),
        screens: JSON.stringify(
          screen?.map((scrn) => ({ ser_screen_id: scrn.value }))
        ),
      };
      try {
        const returned = await getAllPostRelatedToTheScreen(jsonObj).unwrap();
        if (
          returned.status === "true" &&
          returned.connection === "true" &&
          returned.message === "Posts available"
        ) {
          setallposts(returned.data);
          setorders(returned.orders);
          settotalduration(returned.total_duration_of_playlist);
        } else {
          setallposts([]);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.error);
      }
    },
    [getAllPostRelatedToTheScreen]
  );

  //get all screen for multiselection dropdrown
  useEffect(() => {
    getAllScreens();
  }, [getAllScreens]);

  //run on page load/re-load
  useEffect(() => {
    if (defaultScreen) {
      getAllPosts(defaultScreen);
    }
  }, [getAllPosts, defaultScreen]);

  // post order changing
  const handleNewOrder = useCallback(
    async (e, pid) => {
      const formObj = new FormData();
      formObj.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      formObj.append("security_token", await GetCookie("es_token"));
      formObj.append("ser_post_id", pid);
      formObj.append("ser_screen_id", defaultScreen[0].value);
      formObj.append("txt_order_no", e.value);

      try {
        const returned = await ChangeOrder(formObj).unwrap();
        if (
          returned.connection === "true" &&
          returned.message === "Order changed successfully" &&
          returned.status === "true"
        ) {
          toast.success(returned.message);
          getAllPosts(defaultScreen);
        } else {
          toast.error(returned.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.status);
        // you can handle errors here if you want to
      }
    },
    [ChangeOrder, defaultScreen, getAllPosts]
  );

  // post deletion
  const handleDeletePost = (pid) => {
    swal({
      title: "Delete Post!",
      text: "Once Deleted, you will not be able to recover this post again!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        try {
          const data = new FormData();
          data.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          data.append("security_token", await GetCookie("es_token"));
          data.append("ser_post_id", pid);

          const res = await deletePost(data).unwrap();
          if (
            res.status === "true" &&
            res.message === "Post deleted successfully" &&
            res.connection === "true"
          ) {
            toast.success(res.message);
            getAllPosts(defaultScreen);
            setAnchorEl(null);
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error.status);
        }
      }
    });
  };

  //this function will change the post order
  const handleChangePostStatus = async (e, pid) => {
    try {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("post_status", !pid.post_status);
      payload.append("ser_post_id", pid.ser_post_id);
      payload.append("ser_screen_id", defaultScreen[0].value);

      const res = await ScreenPostStatusChange(payload).unwrap();
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Post status updated successfully"
      ) {
        toast.success(res.message);
        getAllPosts(defaultScreen);
      } else if (res.connection === "true" && res.status === "false") {
        toast.info(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //add new post button click
  const addnewpost = () => {
    navigate("/addnewpost", {
      state: {
        track: defaultScreen,
        allscreens: options,
      },
    });
  };

  const playpost = (post) => {
    setdata({
      ...data,
      playingpost: true,
      selectedpost: post,
    });
  };

  const closeVideo = () => {
    setdata({
      ...data,
      playingpost: false,
      selectedpost: null,
    });
  };
  const handleSchduleModal = (post) => {
    setdata({
      ...data,
      selectedpost: post,
      screenwisePostStatuscomponent: true,
    });
  };
  const handleSchduleModalClose = () => {
    setdata({
      ...data,
      selectedpost: null,
      screenwisePostStatuscomponent: false,
    });
  };

  // const handleRefreshScreen = () => {
  //   swal({
  //     title: "Refresh Screen!",
  //     text: "This will just refresh the screen nothing with lose!",
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   })
  //     .then(async (willUnLink) => {
  //       const payload = new FormData();
  //       payload.append(
  //         "txt_customer_id",
  //         localStorage.getItem("txt_customer_id")
  //       );
  //       payload.append("security_token", await GetCookie("es_token"));
  //       payload.append("ser_screen_id", location.state.screens[0].value);
  //       const res = await refreshscreen(payload).unwrap();
  //       if (
  //         res.connection === "true" &&
  //         res.status === "true" &&
  //         res.message === "Screen refreshed automatically"
  //       ) {
  //         toast.success(res.message);
  //       } else {
  //         toast.error(res.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  const GotoEditPostPage = (post) => {
    navigate("/editPost", { state: post });
  };

  return (
    <>
      {isLoading ||
      loading ||
      changeorderloading ||
      deleteloading ||
      screenwisePostStatusloading ? (
        <LoadingSpinner />
      ) : null}
      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        <div className="row justify-content-between mt-2 no-gutters">
          <div className="col col-sm-6 col-md-6 col-lg-6">
            <div className="w-full md:w-8">
              {!defaultScreen ? null : (
                <Select
                  options={options}
                  defaultValue={defaultScreen}
                  onChange={setDefaultScreen}
                  isMulti="true"
                  isClearable={true}
                  placeholder="Select screen"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
              )}
            </div>
          </div>
          <div className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end">
            {totalduration && (
              <Button
                variant="contained"
                sx={{ maxHeight: "40px" }}
                disableRipple
                startIcon={<AccessTimeIcon />}
                className="mr-1 capitalized fs-14 fw-bold"
              >
                {totalduration}
              </Button>
            )}
            <Button
              variant="contained"
              sx={{ maxHeight: "40px" }}
              startIcon={<Add />}
              onClick={addnewpost}
              className="mr-1 capitalized fs-14 fw-bold"
            >
              Add Post
            </Button>
          </div>
        </div>
        <Box sx={{ flexGrow: 1 }}>
          {allposts?.length > 0 ? (
            <Grid container spacing={2}>
              {allposts?.map((post, index) => (
                <Grid item xs={12} md={4} lg={4} key={index}>
                  <Item>
                    <div
                      className="surface-0 shadow-2 p-3"
                      style={{ borderRadius: "8px" }}
                    >
                      <div className="flex justify-content-between align-items-center mb-2">
                        <span className="font-bold flex align-items-center justify-content-center">
                          {defaultScreen?.length === 1 ? (
                            <span
                              className="mr-2 d-flex justify-content-center align-items-center"
                              style={{
                                backgroundColor: "#F0F0F0",
                                borderRadius: "50%",
                                width: "35px",
                                height: "35px",
                              }}
                            >
                              {post.order_no}
                            </span>
                          ) : null}
                          {post.txt_post_title}
                        </span>
                        {defaultScreen?.length === 1 ? (
                          <div className="flex align-items-center justify-content-center">
                            <MoreVertIcon
                              onClick={(e) => handleClick(e, post.ser_post_id)}
                            />
                          </div>
                        ) : null}
                      </div>
                      <Divider
                        sx={{
                          bgcolor: (theme) => theme.palette.divider,
                          my: 0.5,
                        }}
                      />
                      {defaultScreen?.length === 1 ? (
                        <>
                          <div className="flex align-items-center justify-content-between">
                            <span className="font-medium mt-1 mb-1">
                              Post Status
                            </span>
                            <div className="flex align-items-center justify-content-center">
                              <Switch
                                onChange={(e) =>
                                  handleChangePostStatus(e, post)
                                }
                                checked={post.post_status}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            </div>
                          </div>

                          <div className="flex align-items-baseline justify-content-between">
                            <div>
                              <span className="font-medium flex align-items-center justify-content-center">
                                Post Order
                              </span>
                            </div>
                            <div className="flex align-items-center justify-content-center">
                              <Select
                                options={orders ? orders : []}
                                name="scudlueddays"
                                value={orders?.filter((ord) =>
                                  ord.value === post.order_no ? ord : null
                                )}
                                onChange={(e) =>
                                  handleNewOrder(e, post.ser_post_id)
                                }
                                isClearable={true}
                                placeholder="Select screen"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          <div className="flex align-items-center justify-content-between">
                            <span className="font-medium mt-1 mb-1">
                              <Link
                                component="button"
                                variant="body2"
                                onClick={() => handleSchduleModal(post)}
                              >
                                Post Schedule
                              </Link>
                            </span>
                          </div>
                        </>
                      ) : null}
                      <Divider
                        sx={{
                          bgcolor: (theme) => theme.palette.divider,
                          my: 1,
                        }}
                      />
                      <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={12} lg={12} xl={6}>
                            <Item>
                              <Button
                                startIcon={<EditIcon />}
                                variant="outlined"
                                sx={{
                                  width: "100%",
                                }}
                                onClick={() => GotoEditPostPage(post)}
                                className="capitalized fs-14 fw-bold"
                              >
                                Edit Post
                              </Button>
                            </Item>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12} xl={6}>
                            <Item>
                              <Button
                                variant="contained"
                                sx={{ width: "100%" }}
                                startIcon={<PlayCircleOutlineIcon />}
                                onClick={() => playpost(post)}
                                className="capitalized fs-14 fw-bold"
                              >
                                Play
                              </Button>
                            </Item>
                          </Grid>
                        </Grid>
                      </Box>
                    </div>
                  </Item>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Empty />
          )}
        </Box>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {defaultScreen?.length === 1 ? (
            <MenuItem
              disableRipple
              onClick={() => handleDeletePost(clickedPost)}
            >
              <DeleteForeverIcon />
              Delete Post
            </MenuItem>
          ) : null}
        </StyledMenu>
      </Box>
      <Modal
        open={data?.playingpost}
        onClose={closeVideo}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "65vh",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
        <PostPlaying post={data?.selectedpost} />
      </Modal>
      {data.screenwisePostStatuscomponent === true ? (
        <ScreenWisePostScheduling
          show={data?.screenwisePostStatuscomponent}
          close={handleSchduleModalClose}
          screen={defaultScreen[0].value}
          schinfo={data?.selectedpost}
          getAllPosts={getAllPosts}
          defaultScreen={defaultScreen}
        />
      ) : null}
    </>
  );
};

export default memo(GetAllPostRelatedToTheScreen);
